import React, { useContext } from 'react';
import { ConfigProvider } from 'antd';
import dayjs from 'dayjs';
import jalaliday from 'jalali-plugin-dayjs';
import calendar from 'dayjs/plugin/calendar';

import 'dayjs/locale/fa';
import 'dayjs/locale/en';

const useJalali = () => {
  const { locale } = useContext(ConfigProvider.ConfigContext);
  React.useEffect(() => {
    dayjs.extend(calendar);
    dayjs.extend(jalaliday);
    (dayjs as any)['calendar']?.('jalali');
    dayjs.locale(locale?.locale === 'fa' ? 'fa' : 'en');
    return () => {
      (dayjs as any)['calendar']?.(undefined);
      dayjs.locale('en');
    };
  }, [locale]);
};

export default useJalali;
